/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
import { dispatchCustomEvent } from '../../utils/custom-event-dispatcher.js';
import { KEYCODE } from '../../utils/keycode.js';

export const TimeInputValidatorMixin = (superClass) =>
  class extends superClass {
    onKeyupValidateTimeInput(event) {
      let h = this.shadowRoot.querySelector('#h-label');
      if (
        (event.keyCode >= KEYCODE.NUM_0 && event.keyCode <= KEYCODE.NUM_9) ||
        (event.keyCode >= KEYCODE.NUMPAD_0 && event.keyCode <= KEYCODE.NUMPAD_9)
      ) {
        //---- If the inputted value > maximum-value for that particular field, then make that field's value as 0 (Internal validation). ----
        if (parseInt(event.target.value, 10) > Number(event.target.max)) {
          event.target.value = event.target == h ? this.getHourValueIfClockFormat24() : '00';
        }
        if (event.target.value == '00' && event.target == h && this.clockFormat === '12-hour') {
          event.target.value = '01';
        }
        if (event.target.value.length === parseInt(event.target.maxLength, 10)) {
          if (
            this.clockFormat === '24-hour' &&
            event.target.nextElementSibling.nextElementSibling == null
          ) {
            this.mini ? (this.m = event.target.value) : (this.s = event.target.value);
          } else {
            event.target.nextElementSibling.nextElementSibling.focus();
            event.target.nextElementSibling.nextElementSibling.setSelectionRange(0, 2);
          }
        }
      } else {
        event.target.value = this._isNonDigit(event.target.value) ? '00' : event.target.value;
      }
      dispatchCustomEvent(this, 'time-value-changed');
    }
    onKeyupValidateAmPm(e) {
      let specialCharacterIsPressed = false;
      specialCharacterIsPressed =
        e.key === ' ' ||
        e.key === 'Backspace' ||
        e.key === 'Tab' ||
        e.key === 'Up' ||
        e.key === 'ArrowUp' ||
        e.key === 'ArrowDown' ||
        e.key === 'Down';

      if (!specialCharacterIsPressed) {
        this.amPm = this._validateAmPmBasedOnInput(e.target.value);
        e.target.value = this.amPm;
      }
      dispatchCustomEvent(this, 'time-value-changed');
    }
    validateTime() {
      this._validateTimeInputModified();
      this.amPm = this.amPm ? this._validateAmPmBasedOnInput(this.amPm) : '';
    }
    getHourValueIfClockFormat24() {
      if (this.clockFormat === '24-hour') {
        return '00';
      } else {
        return '01';
      }
    }
    _validateTimeInputModified() {
      this.h = this.h
        ? this._isNonDigit(this.h)
          ? this.getHourValueIfClockFormat24()
          : this.h
        : '';
      this.m = this.m ? (this._isNonDigit(this.m) || this.m > 59 ? '00' : this.m) : '';
      this.s = this.s ? (this._isNonDigit(this.s) || this.s > 59 ? '00' : this.s) : '';
      this.h =
        this.h > 12 && this.clockFormat === '12-hour'
          ? '01'
          : this.h > 23 && this.clockFormat === '24-hour'
          ? '00'
          : this.h;
    }
    _isNonDigit(input) {
      return input.toString().match(/\D/i) !== null;
    }
    _validateAmPmBasedOnInput(input) {
      let valueOfAmPmInput = input.toString().toLowerCase();
      if (valueOfAmPmInput.length === 2) {
        return valueOfAmPmInput != 'am' && valueOfAmPmInput != 'pm'
          ? 'AM'
          : valueOfAmPmInput === 'pm' || valueOfAmPmInput === 'am'
          ? valueOfAmPmInput.toUpperCase()
          : '';
      } else if (valueOfAmPmInput.length === 1) {
        return valueOfAmPmInput !== 'p' ? 'AM' : 'PM';
      } else if (valueOfAmPmInput.length > 2) {
        return 'AM';
      }
    }
  };
